import React from "react";
import RewardSystemEarnMoreView from "../components/reward-system-earn-more-view";
import { REWARD_EARN_MORE } from "../graphql/rewardSubscription.gql";
import { withApollo } from '@apollo/client/react/hoc';
import { compose } from "modules/core";

const RewardSystemEarnMoreContainer = (props) => {
  const { client, rewardPermission } = props;
  const [activityList, setActivityList] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    if (rewardPermission && rewardPermission.reward_earn_more_permissions)
      getHistoryData();
    else if (rewardPermission && rewardPermission.reward_earn_more_permissions === false)
      setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rewardPermission]);
  const getHistoryData = async (endCursor) => {
    try {
      const { data } = await client.query({
        query: REWARD_EARN_MORE,
        fetchPolicy: 'network-only',
        variables: { endCursor: endCursor },
      });
      if (data) {
        const allActivities = data
          ?.earnMore
          ?.map(ele => ({ title: ele?.category?.name, points: ele.points, path: ele.path }))
          ?.filter(ele => ele.path !== null) || [];
        setActivityList(allActivities);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching reward history:", error);
      setLoading(false);
    }
  }
  return (
    <RewardSystemEarnMoreView
      activityList={activityList}
      loading={loading}
      permission={rewardPermission?.reward_earn_more_permissions}
      {...props}
    />
  );
}

export default compose(withApollo)(RewardSystemEarnMoreContainer);